import { liveSearchParams } from '@features/map/liveSearchParams'
import { generatePath, Navigate, Outlet } from 'react-router'
import { useIsDealerOrg, useOrgCodeOrThrow } from 'shared-ui/active-operation'
import { urlHasLayerSelection, useIsBrowsing } from 'shared-ui/map'

import { path } from '../../../routes/paths'
import { DEALER_TAB_PARAM, DealerMapTab } from '../hooks/useDealerMapTab'

/**
 * A dealership browses its fields on the dealership map, so the field map is
 * theirs only for viewing one field. Whatever lands them on its field list — a
 * typed URL, or leaving a field from inside it — sends them back across,
 * carrying the filter so a client or farm chosen on the way survives the trip.
 */
export const DealerFieldListRedirect: React.FC = () => {
  const orgCode = useOrgCodeOrThrow()
  const isDealerOrg = useIsDealerOrg()
  const isBrowsing = useIsBrowsing()

  // The store alone won't answer this: it lags the URL by an effect, so a
  // deep-linked field reports browsing on its first render.
  const currentParams = liveSearchParams()
  const showsFieldList = isBrowsing && !urlHasLayerSelection(currentParams)

  if (!isDealerOrg || !showsFieldList) return <Outlet />

  currentParams.set(DEALER_TAB_PARAM, DealerMapTab.MyData)

  return (
    <Navigate
      to={{
        pathname: generatePath(path.dealerMap, { orgCode }),
        search: currentParams.toString()
      }}
      replace
    />
  )
}
